export default {
  env: 'test',
  test: true,
  host: 'app.crossbeam-dev.com',
  appcuesEnabled: false,
  apiBaseUrl: 'https://api.crossbeam-dev.com',
  salesEdgeBaseUrl: 'https://sales-backend-api.cb.c7m.io',
  salesEdgeRedirectUrl: 'https://sales.cb.c7m.io',
  salesforceReauthUrl: 'lightning/n/xbqa__Setup',
  postHog: null,
  hubSpotForms: {
    contactSalesForm: '4ca71264-cb55-4f5c-8cae-440686ab46bd',
    envID: '5767578',
  },
  enableGoogleTags: false,
  statusPageEmbedUrl: null,
  iteratively: {
    environment: 'test',
  },
  statuspageBaseUrl: 'https://crossbeamstaging.statuspage.io',
  statuspagePageId: '6dcrv6nnlbkg',
  statusWidget: null,
  chargify: {
    publicKey: 'fake-key',
    serverHost: 'fake-server-host',
  },
  segment: { enabled: false },
  liveRampTagId: '713285',
  agentBaseUrl: 'https://agent.crossbeam-dev.com',
  aiChatHost: 'agent.crossbeam-dev.com',
  logoDevPublicKey: 'pk_JzJ-unVJSx6Zd7MX1uKUog',
} as const;
